import * as React from 'react'
import Chart from 'echarts-for-react/lib/core'
import { getCategories, getPrimarySeries, getLegend, getTitle, getPrimaryAxisLabel, getToolbox } from 'helpers/charts'
import { tryParseJSON } from 'helpers/utils'
import { DashboardContext } from 'helpers/dashboards'

function Component(props) {
  const { echarts, theme } = React.useContext(DashboardContext)
  const { chart, section, data, showToolbox } = props
  const { dimensionTitle, showGridlines, primaryMetricTitle } = tryParseJSON(chart.chartJson, {})

  const option = {
    toolbox: showToolbox ? getToolbox({ theme }) : undefined,
    tooltip: {},
    grid: { containLabel: true },
    title: getTitle({ chart }),
    legend: getLegend({ chart }),
    xAxis: {
      type: 'value',
      name: primaryMetricTitle,
      splitLine: { show: showGridlines },
      axisLabel: getPrimaryAxisLabel({ chart }),
    },
    yAxis: {
      type: 'category',
      data: getCategories({ data }),
      name: dimensionTitle,
      splitLine: { show: showGridlines },
    },
    series: getPrimarySeries({ chart, data }),
  }

  return (
    <Chart
      echarts={echarts}
      theme={theme?.name}
      style={{ width: '100%', minHeight: `${section.height}px` }}
      option={option}
    />
  )
}

export default Component
